import React from "react";
import { Star } from "lucide-react";
import Button from "./atoms/Button";

const reviews = [
  {
    name: "Kevin Rabineau",
    title: "We suffered significant roof and gutter damage from a storm",
    body:
      "Roach Home Improvement worked with our insurance company and made the paperwork pretty painless. The crew came in and installed our new roof in a single day.",
  },
  {
    name: "Nic Liceaga",
    title: "Definitely recommend Roach! Such a good experience",
    body:
      "They were super nice and they didn't mind getting more into detail because I needed a little more assurance after what I went through with another company.",
  },
  {
    name: "Wesley Fry",
    title: "100% call backs, information asap, and they show up on time",
    body:
      "The best place I've ever dealt with! We had different crews come for our home work and every time they were polite, respectful and cleaned up like I'd want.",
  },
];

const Stars = ({ size = 14 }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={size} className="text-yellow-400 fill-yellow-400" />
    ))}
  </div>
);

const CityHappyCustomers = () => (
  <section className="py-12 md:py-20 bg-neutral-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-10 items-start">
        <div className="lg:col-span-1 text-center lg:text-left">
          <div className="text-5xl md:text-6xl font-display font-extrabold text-neutral-900 leading-none mb-3">
            4.9<span className="text-neutral-400 font-bold">/5</span>
          </div>
          <div className="flex justify-center lg:justify-start mb-5">
            <Stars size={20} />
          </div>
          <h2 className="text-2xl md:text-3xl font-display font-extrabold text-neutral-900 mb-3 leading-tight">
            Hundreds of <span className="text-brand-500">Happy</span>
            <br className="hidden lg:inline" /> Customers
          </h2>
          <p className="text-neutral-600 text-sm leading-relaxed mb-6 max-w-sm mx-auto lg:mx-0">
            Real reviews from real customers — see what they have to say about
            their experience with us.
          </p>
          <Button color="red" size="default" to="/contact/">
            Request a FREE Estimate Now
          </Button>
        </div>

        <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div
              key={r.name}
              className="bg-white rounded-2xl border border-neutral-200 shadow-sm hover:shadow-md transition-shadow p-6 flex flex-col"
            >
              <p className="font-bold text-neutral-900 leading-snug mb-3">
                {r.title}
              </p>
              <Stars />
              <p className="text-sm text-neutral-700 leading-relaxed mt-3 mb-5 flex-grow">
                {r.body}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-neutral-100">
                <div className="w-9 h-9 rounded-full bg-neutral-200 flex-shrink-0" />
                <span className="text-sm font-semibold text-neutral-800">
                  {r.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default CityHappyCustomers;
